import {DataServiceBase} from "../DataServiceBase";

export class PaymentsService extends DataServiceBase{
    constructor() {
        super('/Payments');
    }
    
    getPaymentsAsync(statusFilter){
        return this.getAsync({ statusFilter: statusFilter }, 'GetPayments');
    }
    
    getPageAsync(model) {
        return this.getAsync(model, 'GetPage');
    }
    
    cancelPaymentAsync(payment) {
        return this.postAsync({ taskScheduleKey: payment.TaskScheduleKey } , 'CancelPayment');
    }

    getFutureRecurringPaymentsAsync(paymentsType){
        return this.getAsync({ paymentsType: paymentsType }, 'GetFutureRecurringPayments');
    }
}